var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorMobbile1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.8 2H6.21001C3.89001 2 2.01001 3.88 2.01001 6.19V12.37V12.56C2.01001 14.88 3.89001 16.75 6.20001 16.75H9.80001C10.35 16.75 10.8 17.2 10.8 17.75V18.57C10.8 19.12 10.35 19.57 9.80001 19.57H7.55001C7.16001 19.57 6.84001 19.89 6.84001 20.28C6.84001 20.67 7.16001 20.99 7.55001 20.99H15.48C15.87 20.99 16.19 20.67 16.19 20.28C16.19 19.89 15.87 19.57 15.48 19.57H13.23C12.68 19.57 12.23 19.12 12.23 18.57V17.75C12.23 17.2 12.68 16.75 13.23 16.75H16.8C19.12 16.75 20.99 14.87 20.99 12.56V12.37V6.19C20.99 3.88 19.11 2 16.8 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 9.5H14.35C12.62 9.5 11.99 10.13 11.99 11.88V19.61C11.99 21.37 12.61 21.99 14.35 21.99H19.64C21.37 21.99 22 21.36 22 19.61V11.88C22 10.12 21.38 9.5 19.64 9.5ZM17 20.32C16.39 20.32 15.9 19.83 15.9 19.22C15.9 18.61 16.39 18.12 17 18.12C17.61 18.12 18.1 18.61 18.1 19.22C18.1 19.83 17.61 20.32 17 20.32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0999 19.22C18.0999 19.83 17.6099 20.32 16.9999 20.32C16.3899 20.32 15.8999 19.83 15.8999 19.22C15.8999 18.61 16.3899 18.12 16.9999 18.12C17.6099 18.12 18.0999 18.62 18.0999 19.22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorMobbile1);
export default __webpack_public_path__ + "static/media/monitor-mobbile-1.d5dde0058296b7296ed7a2a3e2f9bacf.svg";
export { ForwardRef as ReactComponent };